import { useValidateInvite } from '@sit/client-shared';
import Preview from 'carbon-react/lib/components/preview';
import I18njs from 'i18n-js';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import PublicPage from '../../components/Shared/Public/PublicPage';
import { registerEmployeeRequest } from '../../redux/User/actions';
import NotFoundPage from '../NotFoundPage';
import InviteForm, { RegisterFormValues } from './InviteForm';

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const Invite = () => {
  const { inviteToken } = useParams<{ inviteToken: string }>();
  const dispatch = useDispatch();
  const { data: user, isLoading, error } = useValidateInvite(inviteToken);

  const handleSubmit = ({ password, passwordConfirm }: RegisterFormValues) => {
    dispatch(
      registerEmployeeRequest({
        inviteToken,
        password,
        passwordConfirm,
        timezone: timeZone,
      }),
    );
  };

  const initialFormValues = {
    username: user?.username ?? '',
    companyId: user?.company.intacctCompanyId ?? '',
    password: '',
    passwordConfirm: '',
  };

  if (error?.response?.status === 404) {
    return <NotFoundPage />;
  }

  return (
    <>
      <Helmet>
        <title>{I18njs.t('helmet.Invite')}</title>
      </Helmet>
      <PublicPage>
        {isLoading ? (
          <Preview loading height="700px" width="450px" />
        ) : (
          <InviteForm initialValues={initialFormValues} onSubmit={handleSubmit} passwordOnly errorMsg={error?.message} />
        )}
      </PublicPage>
    </>
  );
};

export default Invite;
